module.exports = __webpack_public_path__ + "img/halo-avater.052491f7.png";